<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4>{{ title }} Campaña Específica</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseCabecera">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Generales
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-xl-12 col-md-12">
                                            <label class="col-form-label required-field" for="intDescripcion">Descripción</label>
                                            <input formControlName="Descripcion" name="Descripcion" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Descripcion')" type="text" value="" aria-describedby="validationDescriptionFeedback" maxlength="150">

                                            <div id="validationDescriptionFeedback" class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required') || isFieldInvalid('Descripcion','cannotContainSpace')">
                                                Descripción es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-xl-4 col-md-4">
                                            <label class="col-form-label required-field" for="IdPais">País</label>
                                            <ng-select appendTo="body"
                                                       [items]="paises"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPais"
                                                       loadingText="Cargando..."
                                                       [loading]="!paises || paises.length === 0"
                                                       placeholder="-- Seleccione un País --"
                                                       [ngClass]="displayFieldCssNgSelect('IdPais')"
                                                       notFoundText="País no encontrado"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div id="validationIdPaisFeedback" class="form-invalid" *ngIf="isFieldInvalid('IdPais', 'cannotBeNullOrZero', false)">
                                                País obligatorio.
                                            </div>
                                        </div>

                                        <div class="form-group col-xl-4 col-md-4">
                                            <label class="col-form-label required-field" for="intModeloCf">Modelo CF</label>
                                            <ng-select appendTo="body"
                                                       loadingText="Cargando..."
                                                       [items]="modelosCf"
                                                       [readonly]="!modelosCf"
                                                       placeholder="-- Seleccione un Modelo CF --"
                                                       [loading]="!modelosCf"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdModeloCf"
                                                       [ngClass]="displayFieldCssNgSelect('IdModeloCf')"
                                                       notFoundText="Modelo CF no encontrado"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div id="validationIdModeloCfFeedback" class="form-invalid" *ngIf="isFieldInvalid('IdModeloCf', 'cannotBeNullOrZero', false)">
                                                Modelo CF obligatorio.
                                            </div>
                                        </div>

                                        <div class="form-group col-xl-4 col-md-4">
                                            <label class="col-form-label" for="IdModeloCf">Idioma CF</label>
                                            <ng-select appendTo="body"
                                                       loadingText="Cargando..."
                                                       [items]="idiomas"
                                                       [readonly]="!idiomas || idiomas.length === 0"
                                                       placeholder="-- Seleccione un Idioma CF --"
                                                       [loading]="!idiomas"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdIdioma"
                                                       [ngClass]="displayFieldCssNgSelect('IdIdioma')"
                                                       notFoundText="Idioma CF no encontrado"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>
